function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

function waitForElement(selector, callback, interval = 100, timeout = 5000) {
  const startTime = Date.now();
  const timer = setInterval(function () {
    const el = document.querySelector(selector);
    if (el) {
      clearInterval(timer);
      callback(el);
    } else if (Date.now() - startTime > timeout) {
      clearInterval(timer);
    }
  }, interval);
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document
    .querySelectorAll("product-model")
    .forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");
    const summaryElements = this.querySelectorAll("summary");
    this.addAccessibilityAttributes(summaryElements);

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    //this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    this.querySelectorAll(".menu-top-close").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );
  }

  addAccessibilityAttributes(summaryElements) {
    summaryElements.forEach((element) => {
      element.setAttribute("role", "button");
      element.setAttribute("aria-expanded", false);
      element.setAttribute("aria-controls", element.nextElementSibling.id);
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector("summary"))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute("open");
    if (detailsElement === this.mainDetailsToggle) {
      log.debug(detailsElement);
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      log.debug(summaryElement.classList);
      if (
        summaryElement.classList.contains("menu-drawer__menu-item") &&
        !isOpen
      ) {
        log.debug("yeah");
        document
          .querySelectorAll(".menu-megamenu .menu-opening[open]")
          .forEach((el) => {
            el.removeAttribute("open");
          });
      }
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );

      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
      });
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event !== undefined) {
      this.mainDetailsToggle.classList.remove("menu-opening");
      document
        .getElementById("header-drawer")
        .classList.remove("menu-opening-mm");
      this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
        details.removeAttribute("open");
        details.classList.remove("menu-opening");
      });
      this.mainDetailsToggle
        .querySelector("summary")
        .setAttribute("aria-expanded", false);
      document.body.classList.remove(
        `overflow-hidden-${this.dataset.breakpoint}`
      );
      removeTrapFocus(elementToFocus);
      this.closeAnimation(this.mainDetailsToggle);
    }
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    event.preventDefault();
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove("menu-opening");
    removeTrapFocus();
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
      this.closest(".header-wrapper").classList.contains(
        "header-wrapper--border-bottom"
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
      document.getElementById("header-drawer").classList.add("menu-opening-mm");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }
}

customElements.define("header-drawer", HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this)
    );
    this.addEventListener("click", (event) => {
      if (event.target.nodeName === "MODAL-DIALOG") this.hide();
    });
    this.addEventListener("keyup", () => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    this.querySelector(".template-popup")?.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");
    button?.addEventListener("click", () => {
      document.querySelector(this.getAttribute("data-modal"))?.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="Deferred-Poster-"]')?.addEventListener(
      "click",
      this.loadContent.bind(this)
    );
  }

  loadContent() {
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      window.pauseAllMedia();
      this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      ).focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector("ul");
    this.sliderItems = this.querySelectorAll("li");
    this.pageCount = this.querySelector(".slider-counter--current");
    this.pageTotal = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    this.scrollContainer = this.querySelector(".product-thumbnails-section");
    this.sliderSmall = this.querySelector(
      ".product-thumbnails-section ul.thumbnails-slider_mobile"
    );
    this.sliderItemsSmall = this.querySelectorAll(
      ".product-thumbnails-section  ul.thumbnails-slider_mobile li"
    );
    this.oldPage;
    this.stableElements = [];

    if (!this.slider || !this.nextButton) return;

    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);
    this.slider.addEventListener("scroll", this.update.bind(this));
    for (this.sliderItemSmall of this.sliderItemsSmall) {
      this.sliderItemSmall.addEventListener(
        "click",
        this.smallIndex.bind(this)
      );
    }

    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
    this.prevButton.addEventListener("click", this.sliderMove.bind(this));
    this.nextButton.addEventListener("click", this.sliderMove.bind(this));
  }

  smallIndex(event) {
    event.preventDefault();
    log.debug(
      document.getElementById("thumbnail-bottom-slider").childElementCount
    );
    let position = jQuery(event.currentTarget).index();
    this.update(position);
    this.slider.scrollTo({
      left: position * this.sliderItems[0].clientWidth,
    });
  }

  initPages() {
    if (!this.sliderItems.length === 0) return;
    if (!this.sliderItemsSmall.length === 0) return;
    this.slidesPerPage = Math.floor(
      this.slider.clientWidth / this.sliderItems[0].clientWidth
    );
    this.totalPages = this.sliderItems.length - this.slidesPerPage + 1;
    this.update();
  }

  update(position) {
    if (!this.pageCount || !this.pageTotal) return;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItems[0].clientWidth) + 1;

    if (this.currentPage === 1) {
      this.prevButton.setAttribute("disabled", true);
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (this.currentPage === this.totalPages / 2) {
      this.nextButton.setAttribute("disabled", true);
    } else {
      this.nextButton.removeAttribute("disabled");
    }
    var position;

    if (position) {
      this.pageCount.textContent = position;
      this.sliderMove(position);
    }

    this.pageCount.textContent = this.currentPage;
    this.pageTotal.textContent = this.totalPages / 2;
    this.sliderMove(this.currentPage, this.oldPage);
    this.oldPage = this.currentPage;
  }

  sliderMove(page, oldPage) {
    const currentPage = page - 1;
    const elementNot =
      ".product-thumbnails-section  ul.thumbnails-slider_mobile li";
    jQuery(elementNot).removeClass("slider__active");
    const element =
      ".product-thumbnails-section  ul.thumbnails-slider_mobile li:eq(" +
      currentPage +
      ")";

    this.sliderSmall.addEventListener("wheel", (evt) => {
      evt.preventDefault();
      this.sliderSmall.scrollLeft += evt.deltaY - 20;
    });

    jQuery(element).addClass("slider__active");

    let newCurrentItem = currentPage + 1;
    let oneStep = Math.floor(
      this.scrollContainer.clientWidth /
        (this.sliderItemsSmall[0].clientWidth + 3)
    );
    let singleElemetnScrollWidth = this.sliderItemsSmall[0].clientWidth + 3;
    let scrollL = singleElemetnScrollWidth * 2;
    let scrollR = singleElemetnScrollWidth * oneStep;

    if (page >= oldPage) {
      if (this.stableElements.includes(newCurrentItem)) {
      } else {
        this.sliderSmall.scrollTo({
          left: newCurrentItem * singleElemetnScrollWidth - scrollR,
        });
        for (let i = 0; i < oneStep - 2; i++) {
          this.stableElements[i] = page - i;
        }
      }
    } else if (page < oldPage) {
      if (this.stableElements.includes(newCurrentItem)) {
      } else {
        this.sliderSmall.scrollTo({
          left: newCurrentItem * singleElemetnScrollWidth - scrollL,
        });
        for (let i = 0; i < oneStep - 2; i++) {
          this.stableElements[i] = page + i;
        }
      }
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + this.sliderItems[0].clientWidth
        : this.slider.scrollLeft - this.sliderItems[0].clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    //this.updatePickupAvailability();
    // log.debug(this.currentVariant);
    if (!this.currentVariant) {
      //this.toggleAddButton(true, '', true);
      // this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this._updatePrice();
      //this.renderProductInfo();
      var selectionData = document.querySelector(".selection-data");
      selectionData.dataset.prodVariantId = this.currentVariant.id;
      selectionData.dataset.prodPrice = this.currentVariant.price * 0.01;
      // log.debug(this.currentVariant);
      if (this.currentVariant.compare_at_price > 0) {
        if (selectionData.dataset.codeDiscount > 0) {
          var discount = selectionData.dataset.codeDiscount;
        } else {
          var discount =
            this.currentVariant.compare_at_price - this.currentVariant.price;
        }
      } else {
        var discount = 0;
      }
      selectionData.dataset.prodDiscount = discount * 0.01;
    }

    var allThumbSmallElement = document.querySelectorAll(
      ".product-thumbnails-section  ul.thumbnails-slider_mobile li"
    );
    for (i = 0; i < allThumbSmallElement.length; i++) {
      allThumbSmallElement[i].classList.remove("slider__active");
    }

    var allThumbSmallElementFirst = document.querySelectorAll(
      ".product-thumbnails-section  ul.thumbnails-slider_mobile li"
    );
    allThumbSmallElementFirst[0].classList.add("slider__active");
  }

  // CUSTOM FOR BOLD (SHOPCIRCLE)
  _emitBoldVariantChange(variant) {
    if (
      typeof BOLD !== "undefined" &&
      typeof BOLD.common !== "undefined" &&
      typeof BOLD.common.eventEmitter !== "undefined"
    ) {
      BOLD.common.eventEmitter.emit("BOLD_COMMON_variant_changed", { variant });
    }
  }
  // CUSTOM FOR BOLD (SHOPCIRCLE)

  _updatePrice() {
    // log.debug( this.currentVariant );
    var selectionData = document.querySelector(".selection-data");
    // CUSTOM FOR BOLD (SHOPCIRCLE)
    var bold_Variant = this.currentVariant;
    // log.debug("BOLD: ", bold_Variant);
    // CUSTOM FOR BOLD (SHOPCIRCLE)

    var priceContainer = document.querySelector(".price-one");
    priceContainer.innerHTML = "";
    if (this.currentVariant.compare_at_price > this.currentVariant.price) {
      priceContainer.innerHTML +=
        `<del data-compare="${this.currentVariant.compare_at_price}" data-price="${this.currentVariant.price}">$` +
        (
          Math.round(
            (this.currentVariant.compare_at_price * 0.01 + Number.EPSILON) * 100
          ) / 100
        ).toFixed(2) +
        "</del> ";
    }
    if (selectionData.dataset.codeDiscount > 0 && false) {
      var currentPrice =
        this.currentVariant.price - selectionData.dataset.codeDiscount;
      priceContainer.innerHTML +=
        `<del data-compare="${this.currentVariant.price}" data-price="${currentPrice}">$` +
        (
          Math.round(
            (this.currentVariant.price * 0.01 + Number.EPSILON) * 100
          ) / 100
        ).toFixed(2) +
        "</del> " +
        '<span class="bold_option_price_display">$' +
        (
          Math.round((currentPrice * 0.01 + Number.EPSILON) * 100) / 100
        ).toFixed(2) +
        "</span>";
    } else {
      priceContainer.innerHTML +=
        '<span class="bold_option_price_display">$' +
        (
          Math.round(
            (this.currentVariant.price * 0.01 + Number.EPSILON) * 100
          ) / 100
        ).toFixed(2) +
        "</span>";
    }

    // CUSTOM FOR BOLD (SHOPCIRCLE)
    setTimeout(() => {
      this._emitBoldVariantChange(bold_Variant);
    }, 500);
    // CUSTOM FOR BOLD (SHOPCIRCLE)
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant || !this.currentVariant?.featured_media) return;
    const newMedia = document.querySelector(
      `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_media.id}"]`
    );

    const newMediaSmall = document.querySelector(
      `[data-media-id="${this.dataset.section}bottom-${this.currentVariant.featured_media.id}"]`
    );
    // log.debug(newMediaSmall);
    // log.debug(newMedia);
    if (!newMedia) return;
    const parent = newMedia.parentElement;
    var mainQueue = document.getElementById("thumbnail-main-slider");
    // mainQueue.removeChild(mainQueue.firstChild);
    // mainQueue.insertAdjacentHTML("afterbegin", newMedia.outerHTML);
    mainQueue.insertBefore(mainQueue.firstChild, mainQueue.lastChild);
    mainQueue.insertBefore(newMedia, mainQueue.firstChild);
    // mainQueue.insertBefore(mainQueue.children[1],mainQueue.lastChild);
    window.setTimeout(() => {
      parent.scroll(0, 0);
    });
    if (newMediaSmall != null) {
      const parentSmall = newMediaSmall.parentElement;
      var bottomQueue = document.getElementById("thumbnail-bottom-slider");
      // bottomQueue.removeChild(bottomQueue.firstChild);
      // bottomQueue.insertAdjacentHTML("afterbegin", newMediaSmall.outerHTML);
      bottomQueue.insertBefore(bottomQueue.firstChild, bottomQueue.lastChild);
      bottomQueue.insertBefore(newMediaSmall, bottomQueue.firstChild);
      // bottomQueue.insertBefore(bottomQueue.children[1],bottomQueue.lastChild);
      window.setTimeout(() => {
        parentSmall.scroll(0, 0);
      });
    }
  }

  updateURL() {
    if (!this.currentVariant) return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant?.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    // log.debug('renderProductInfo');
    // log.debug(this.currentVariant.compare_at_price);
    if (
      this.currentVariant.compare_at_price == null ||
      this.currentVariant.compare_at_price == 0
    ) {
      // log.debug('this.currentVariant.compare_at_price == null || this.currentVariant.compare_at_price == 0');
      jQuery("#product-price > .price").removeClass("price--on-sale");
      // log.debug('remove price on sale');
    } else if (!jQuery(".product-price > .price").hasClass("price--on-sale")) {
      // log.debug('.product-price > .price has class price--on-sale');
      jQuery("#product-price> .price").addClass("price--on-sale");
      log.debug("set price on sale");
    }
    if (this.currentVariant.compare_at_price > this.currentVariant.price) {
      // log.debug('compare price > price');
      //var prriice = document.querySelector('.prriice.bold_option_price_display');
      //if(prriice !== null) {
      //  prriice.classList.remove('bold_option_price_display');
      //}
      var priceToUpdate = document.querySelector(
        ".price__sale .price-item.price-item--regular "
      );
      var priceCompareToUpdate = document.querySelector(
        ".price__compare .price-item.price-item--regular "
      );
      // log.debug(priceToUpdate);
      if (priceCompareToUpdate) {
        priceCompareToUpdate.dataset.price = (
          Math.round(this.currentVariant.compare_at_price) / 100
        ).toFixed(2);
      }

      priceToUpdate.innerHTML =
        "$" +
        (Math.round(this.currentVariant.compare_at_price) / 100).toFixed(2);
      var priceToUpdate = document.querySelector(
        ".price__last .price-item.price-item--sale "
      );
      if (!priceToUpdate.classList.contains("bold_option_price_display")) {
        priceToUpdate.classList.add("bold_option_price_display");
        // log.debug('bold price added');
      }
      priceToUpdate.dataset.price = (
        Math.round(this.currentVariant.price) / 100
      ).toFixed(2);
      priceToUpdate.innerHTML =
        "$" + (Math.round(this.currentVariant.price) / 100).toFixed(2);
      // setTimeout(function(){
      //   priceToUpdate.innerHTML = 'A$' + priceToUpdate.dataset.price;

      // }, 1000);
    } else if (
      document.querySelector(".price-item.price-item--regular span") != null
    ) {
      // log.debug('price regular');
      var prriice = document.querySelector(".prriice");
      if (prriice !== null) {
        prriice.classList.add("bold_option_price_display");
      }
      var priceToUpdate = document.querySelector(
        ".price-item.price-item--regular span"
      );
      priceToUpdate.dataset.price = (
        Math.round(this.currentVariant.price) / 100
      ).toFixed(2);
      priceToUpdate.innerHTML =
        "$" + (Math.round(this.currentVariant.price) / 100).toFixed(2);
      // setTimeout(function(){
      //   priceToUpdate.innerHTML = 'A$' + priceToUpdate.dataset.price;

      // }, 1000);
    } else {
      // log.debug('price else');
      var priceToUpdate = document.querySelector(
        ".price-item.price-item--regular"
      );
      priceToUpdate.innerHTML =
        '<span class="prriice" data-price="' +
        (Math.round(this.currentVariant.price) / 100).toFixed(2) +
        '">$' +
        (Math.round(this.currentVariant.price) / 100).toFixed(2) +
        "</span>";
      var priceAddClass = document.querySelector(".prriice");
      priceAddClass.classList.add("bold_option_price_display");
      // log.debug(priceAddClass.textContent);
      setTimeout(function () {
        // log.debug('ee');
        if (priceAddClass.textContent == "$0.00") {
          priceAddClass.textContent = "$" + priceAddClass.dataset.price;
        }
        priceAddClass.innerHTML = "$" + priceAddClass.dataset.price;
      }, 1000);
    }

    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.remove("visibility-hidden");
    this.toggleAddButton(
      !this.currentVariant.available,
      window.variantStrings.soldOut
    );
    // fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
    //   .then((response) => response.text())
    //   .then((responseText) => {
    //     const id = `price-${this.dataset.section}`;
    //     const html = new DOMParser().parseFromString(responseText, 'text/html')
    //     const destination = document.getElementById(id);
    //     const source = html.getElementById(id);

    //     if (source && destination) destination.innerHTML = source.innerHTML;

    //     document.getElementById(`price-${this.dataset.section}`)?.classList.remove('visibility-hidden');
    //     this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
    //   });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    // log.debug('toggleAddButton');

    var addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector(".product-form__submit.bold_clone");
    // check if bold button exist , if not find other add to cart button
    if (addButton === null) {
      addButton = document
        .getElementById(`product-form-${this.dataset.section}`)
        ?.querySelector(".product-form__submit");
    }

    const notifyButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector(".klaviyo-bis-trigger");

    const bottomButton = document.getElementById("cart-bar-add");
    log.debug(bottomButton);
    if (!addButton) return;
    // log.debug(this.currentVariant );
    if (disable) {
      // log.debug('if disable');

      if (this.currentVariant == undefined) {
      } else if (this.currentVariant.available == false) {
        addButton.setAttribute("disabled", true);
        bottomButton.setAttribute("disabled", true);
        if (text) {
          addButton.textContent = text;
          bottomButton.textContent = text;
        } else {
          addButton.textContent = "Sold Out";
          bottomButton.textContent = "Sold Out";
        }
        if (notifyButton != null) {
          notifyButton.classList.remove("hidden");
          notifyButton.classList.add("vis");
        }
      } else if (this.currentVariant.available == true) {
        if (notifyButton != null) {
          notifyButton.classList.add("hidden");
          notifyButton.classList.remove("vis");
        }
        addButton.removeAttribute("disabled");
        addButton.classList.remove("no-selection");
        bottomButton.removeAttribute("disabled");
        document
          .getElementById(`product-form-${this.dataset.section}`)
          ?.querySelector(".product-form__submit:not(.bold_clone)")
          .removeAttribute("disabled");
        addButton.textContent = window.variantStrings.addToCart;
        bottomButton.textContent = window.variantStrings.addToCart;
      }
    } else {
      // log.debug('if disable false');
      if (this.currentVariant == undefined) {
      } else if (this.currentVariant.available == true) {
        if (notifyButton != null) {
          notifyButton.classList.add("hidden");
          notifyButton.classList.remove("vis");
        }
        // log.debug('here 2');
      }

      if (this.currentVariant == undefined) {
      } else if (this.currentVariant.available == false) {
        if (notifyButton != null) {
          notifyButton.classList.remove("hidden");
          notifyButton.classList.add("vis");
        }
        // log.debug('here');
      }
      addButton.removeAttribute("disabled");
      bottomButton.removeAttribute("disabled");
      addButton.classList.remove("no-selection");

      addButton.textContent = window.variantStrings.addToCart;
      bottomButton.textContent = window.variantStrings.addToCart;
      document
        .getElementById(`product-form-${this.dataset.section}`)
        ?.querySelector(".product-form__submit:not(.bold_clone)")
        .removeAttribute("disabled");
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const addButton = document
      .getElementById(`product-form-${this.dataset.section}`)
      ?.querySelector(".product-form__submit.bold_clone");
    const bottomButton = document.getElementById("cart-bar-add");

    if (!addButton) return;
    addButton.textContent = window.variantStrings.unavailable;
    bottomButton.textContent = window.variantStrings.unavailable;
    document
      .getElementById(`price-${this.dataset.section}`)
      ?.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
function getCookie(cname) {
  let name = cname + "=";
  let ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

var mainEl = document.getElementById("select-geolocation__popup");
var background_popup = document.getElementById("background-geolocation__popup");
var closeButton = document.getElementById("geolocation-popup__close-button");
var buttonGeolocation = document.getElementById("geolocation__popup");
var buttonGeolocationFooter = document.getElementById(
  "geolocation__popup-footer"
);
var buttonGeolocationMobileMenu = document.getElementById(
  "geolocation__popup-mobile-menu"
);
var topMenuButton = document.getElementById("location-top__banner-content");
var topMenuButtonFooter = document.getElementById(
  "location-top__banner-content-footer"
);
var topMenuButtonMobileMenu = document.getElementById(
  "location-top__banner-mobile-menu"
);
var australiaButton = document.getElementById("australia-geolocation");
// var newzealandButton = document.getElementById("newzealand-geolocation");
var singaporeButton = document.getElementById("singapore-geolocation");
// var malaysiaButton = document.getElementById("malaysia-geolocation");
var canadaButton = document.getElementById("canada-geolocation");
//var usaButton = document.getElementById("usa-geolocation");

var changeLocationButton = document.querySelectorAll(".geolocation");

var newZealandImg =
  "<img src='https://cdn.shopify.com/s/files/1/0570/2218/5644/files/newzealand-flag.png?v=1640178730' alt='Desky New Zealand' width='21px' height='21px' class='top-icon'><span id='location-top__banner-name' class='menu-item-title'> New Zealand </span> ";
var australiaImg =
  "<img src='https://cdn.shopify.com/s/files/1/0570/2218/5644/files/australia-flag.png?v=1640126990'   alt='Desky Australia' width='21px' height='21px' class='top-icon'><span id='location-top__banner-name' class='menu-item-title'> Australia </span> ";
var singaporeImg =
  "<img src='https://cdn.shopify.com/s/files/1/0605/8075/7653/files/singapore-flag.png?v=1642517587'   alt='Desky Singapore' width='21px' height='21px' class='top-icon'><span id='location-top__banner-name' class='menu-item-title'> Singapore </span> ";

var canadaImg =
  "<img src='https://cdn.shopify.com/s/files/1/0570/2218/5644/files/canada-flag.png'   alt='Desky Canada' width='21px' height='21px' class='top-icon'><span id='location-top__banner-name' class='menu-item-title'> Canada EN</span> ";
var canadaImgFR =
  "<img src='https://cdn.shopify.com/s/files/1/0570/2218/5644/files/canada-flag.png'   alt='Desky Canada' width='21px' height='21px' class='top-icon'><span id='location-top__banner-name' class='menu-item-title'> Canada FR</span> ";
var usaImg =
  "<img src='https://cdn.shopify.com/s/files/1/0666/0220/5506/files/usa-flag.png?v=1666285305'   alt='Desky USA' width='21px' height='21px' class='top-icon'><span id='location-top__banner-name' class='menu-item-title'> USA </span> ";

if (getCookie("loc_popup") != "closed") {
  // mainEl.classList.remove('hide');
  checkLocation();
}

topMenuButton.innerHTML = usaImg;
topMenuButtonFooter.innerHTML = usaImg;
topMenuButtonMobileMenu.innerHTML = usaImg;

background_popup.addEventListener("click", geolocationPopup);
closeButton.addEventListener("click", geolocationPopup);
buttonGeolocation.addEventListener("click", geolocationPopup);
buttonGeolocationFooter.addEventListener("click", geolocationPopup);
buttonGeolocationMobileMenu.addEventListener(
  "click",
  geolocationPopupMobileMenu
);
australiaButton.addEventListener(
  "click",
  function () {
    changeLocation("australia");
  },
  false
);
// newzealandButton.addEventListener('click',function(){changeLocation('newzealand');}, false);
// singaporeButton.addEventListener('click',function(){changeLocation('singapore');}, false);
// malaysiaButton.addEventListener('click',function(){changeLocation('malaysia');}, false);
// if (canadaButton) {
//   canadaButton.addEventListener('click',function(){changeLocation('canada');}, false);
// }
//usaButton.addEventListener('click',function(){changeLocation('usa');}, false);

changeLocationButton.forEach(function (item, index) {
  setCookie("loc_popup", "closed", 1);
});

function geolocationPopupMobileMenu(e) {
  e.preventDefault();
  document.querySelector("summary").click();
  geolocationPopup();
}

function geolocationPopup() {
  var mainEl = document.getElementById("select-geolocation__popup");
  if (mainEl.classList.contains("hide")) {
    mainEl.classList.remove("hide");
  } else {
    mainEl.classList.add("hide");
    setCookie("loc_popup", "closed", 1);
  }
}

function changeLocation(location) {
  setCookie("loc_popup", "closed", 1);
  if (location == "australia") {
    topMenuButton.innerHTML = australiaImg;
    topMenuButtonFooter.innerHTML = australiaImg;
    topMenuButtonMobileMenu.innerHTML = australiaImg;
    // }else if (location == "newzealand"){
    //   topMenuButton.innerHTML=newZealandImg;
    //   topMenuButtonFooter.innerHTML=newZealandImg;
    //   topMenuButtonMobileMenu.innerHTML=newZealandImg;
  } else if (location == "singapore") {
    topMenuButton.innerHTML = singaporeImg;
    topMenuButtonFooter.innerHTML = singaporeImg;
    topMenuButtonMobileMenu.innerHTML = singaporeImg;
  } else if (location == "canada") {
    topMenuButton.innerHTML = canadaImg;
    topMenuButtonFooter.innerHTML = canadaImg;
    topMenuButtonMobileMenu.innerHTML = canadaImg;
  } else if (location == "usa") {
    topMenuButton.innerHTML = usaImg;
    topMenuButtonFooter.innerHTML = usaImg;
    topMenuButtonMobileMenu.innerHTML = usaImg;
  }
}

function compareCountries(country) {
  var currentURL = window.location.href;
  var urlCurrentCheck;
  log.debug(Shopify);
  if (currentURL.indexOf("com.au") > 0) {
    urlCurrentCheck = "Australia";
  } else if (currentURL.indexOf("com") > 0) {
    urlCurrentCheck = "United States";
  } else if (currentURL.indexOf("co.nz") > 0) {
    urlCurrentCheck = "New Zealand";
  } else if (currentURL.indexOf("sg") > 0) {
    urlCurrentCheck = "Singapore";
  } else if (
    currentURL.indexOf("ca") > 0 ||
    currentURL.indexOf("desky-nz") > 0
  ) {
    urlCurrentCheck = "Canada";
    if (navigator.language == "fr-CA" && Shopify.locale == "en") {
      return false;
    }
  }

  if (urlCurrentCheck == country) {
    return true;
  } else {
    return false;
  }
}
function checkLocation() {
  var userCountry = getCookie("userCountry");
  log.debug("userCountry", userCountry);
  log.debug("navigator.language", navigator.language);
  if (userCountry == "undefined" || !getCookie("userCountry")) {
    jQuery.get("/browsing_context_suggestions.json", (r) => {
      // do something more interesting than console

      log.debug("r.detected_values.country", r.detected_values.country);

      userCountry = r.detected_values.country.name;
      setCookie("userCountry", userCountry, 30);
      if (!compareCountries(userCountry)) {
        geolocationPopup();
      } else {
        setCookie("loc_popup", "closed", 1);
      }
    });
  } else {
    if (!compareCountries(userCountry)) {
      geolocationPopup();
    } else {
      setCookie("loc_popup", "closed", 1);
    }
  }
}

function closeTopBarDiscount() {
  if (!getCookie("topBarDiscount")) {
    $(".very-top-bar").addClass("active");
  } else {
  }
  $(".very-top-bar").on("click", ".close-button", function () {
    setCookie("topBarDiscount", "closed", 1);
    $(".very-top-bar").removeClass("active");
  });
}
closeTopBarDiscount();

function closeAfterHeaderBar() {
  if (!getCookie("afterHeaderBar")) {
    $(".nav-usps").addClass("active");
  } else {
  }
  $(".nav-usps").on("click", ".close-button", function () {
    setCookie("afterHeaderBar", "closed", 1);
    $(".nav-usps").removeClass("active");
  });
}
closeAfterHeaderBar();
// var quantityInputs = document.querySelectorAll('.main-cart__slider .quantity__input');

// quantityInputs.forEach(element => {
//   log.debug(element);
//   element.addEventListener('keypress', logKey);
// });
// document.addEventListener('keypress', logKey);
// function logKey(e) {
//   log.debug(e.target.classList.contains('quantity__input'));
//   log.debug(e.target.closest('.btns-slider'));
//   if(e.target.closest('.btns-slider') && e.target.classList.contains('quantity__input') && (e.code == 'Enter' || e.code == 'NumpadEnter')){
//     e.preventDefault();
//   }
// }

const liveChat = document.querySelector("#reamaze-widget");
const footerrLiveChat = document.querySelector("#footer-open-chat");

waitForElement("#reamaze-widget", function (liveChat) {
  footerrLiveChat.addEventListener("click", function () {
    liveChat.click();
  });
});

var topLiveChat = document.getElementById("top-menu-chat");
var footerLiveChat = document.getElementById("footer-open-chat");
let openHide = false;

if (topLiveChat) {
  topLiveChat.addEventListener("click", chatWithUsLive);
}
footerLiveChat.addEventListener("click", chatWithUsLive);
function chatWithUsLive() {
  if (openHide == false) {
    LiveChatWidget.call("maximize");
    openHide = true;
  } else if (openHide == true) {
    LiveChatWidget.call("minimize");
    openHide = false;
  }
}

let dropdownDesc = {
  // desk tops - which sizes are available in which colours
  // which legs colours are available
  // find all options with given desk top colour
  // find all oos options with given desk colour
  // if all variants with given desk colour are oos set desk colour to oos
  // if all variants with given desk size are not available set desk size to oos
  // if all variants with given leg colour are not available set leg to oos
  // when desk colour in given size is not available, then size should be set to oos if desk colour is selected  or if size is selected then colours with this size should be oos
  selectedOptions: {
    option1: "",
    option2: "",
    option3: "",
  },
  closeDropdown: function (target) {
    $(target)
      .closest(".dropdown-option")
      .find(".dropdown-items")
      .removeClass("active");
  },
  findOosColours: function () {
    var _this = this;
    var allColours = [...new Set(prodVariants.map((item) => item.option1))];
    var availableColours = [];

    allColours.forEach((item) => {
      var inStockVariants = prodVariants.filter((obj) => {
        return obj.option1 === item && obj.available == true;
      });
      if (inStockVariants.length > 0) {
        availableColours.push(item);
      }
    });

    var notAvailableColours = allColours.filter(
      (x) => !availableColours.includes(x)
    );
    _this.setOos(
      notAvailableColours,
      '.dropdown-option[data-option="1"] .dropdown-item'
    );
  },
  setOos: function (props, parent) {
    props.forEach((prop) => {
      $(parent).each(function () {
        if ($(this).text() == prop) {
          $(this).addClass("oos");
        }
      });
    });
  },
  findOos: function (option1, option2, option3) {
    var oos = {
      option1: [],
      option2: [],
      option3: [],
    };
    var inStock = {
      option1: [],
      option2: [],
      option3: [],
    };
    if (option1 != "") {
      var oosVariants = prodVariants.filter((obj) => {
        return obj.option1 === option1 && obj.available == false;
      });
      var inStockVariants = prodVariants.filter((obj) => {
        return obj.option1 === option1 && obj.available == true;
      });
    }

    oosVariants.forEach((result) => {
      oos.option2.push(result.option2);
    });
    inStockVariants.forEach((result) => {
      inStock.option2.push(result.option2);
    });
    oos.option2 = [...new Set(oos.option2)];
    inStock.option2 = [...new Set(inStock.option2)];
    oos.option2 = oos.option2.filter((x) => !inStock.option2.includes(x));

    return oos;
  },
  findOosLegs: function (option1, option2) {
    var oos = {
      option1: [],
      option2: [],
      option3: [],
    };
    var inStock = {
      option1: [],
      option2: [],
      option3: [],
    };

    var oosVariants = prodVariants.filter((obj) => {
      return (
        obj.option1 === option1 &&
        obj.option2 === option2 &&
        obj.available == false
      );
    });

    var inStockVariants = prodVariants.filter((obj) => {
      return (
        obj.option1 === option1 &&
        obj.option2 === option2 &&
        obj.available == true
      );
    });

    oosVariants.forEach((result) => {
      oos.option3.push(result.option3);
    });
    inStockVariants.forEach((result) => {
      inStock.option3.push(result.option3);
    });
    oos.option3 = [...new Set(oos.option3)];

    return oos;
  },
  setPreorder: function () {
    // if preorder value selected, add info about preorder to selected item
    log.debug("setPreorder");
    var selectedItems = [];

    // get current selects
    $(".dropdown-item.selected").each(function () {
      log.debug(
        $(this).closest(".dropdown-option").data("option") - 1,
        $(this).data("index"),
        $(this).data("preorder-message") ? $(this).data("preorder-message") : ""
      );
      selectedItems.push({
        optionNr: $(this).closest(".dropdown-option").data("option") - 1,
        indexNr: $(this).data("index"),
        preorderMessage: $(this).data("preorder-message")
          ? $(this).data("preorder-message")
          : "",
      });
    });

    //get current variant
    let url = new URL(window.location.href); // Use window.location.href to get the current URL
    let params = new URLSearchParams(url.search);
    let currentVariant = params.get("variant");
    log.debug(variantsOnPreorder);
    log.debug(selectedItems);

    function sortMessagesByPreorder(messages, preorderMessages) {
      return messages.sort((a, b) => {
        return (
          preorderMessages.indexOf(a.preorderMessage) -
          preorderMessages.indexOf(b.preorderMessage)
        );
      });
    }

    // array.find(item => item.optionNr === 1);
    var preorderText = "";
    var option0Message = selectedItems.find((item) => item.optionNr === 0)
      ? selectedItems.find((item) => item.optionNr === 0).preorderMessage
      : "";
    var currentVariantPreorderMessage = variantsOnPreorder.find(
      (item) => item.variant_id === currentVariant
    )
      ? variantsOnPreorder.find((item) => item.variant_id === currentVariant)
          .preorderMessage
      : "";
    // log.debug(option0Message, currentVariantPreorderMessage);
    var preorderText = "";

    // is current variant on preorder
    if (currentVariantPreorderMessage.length > 0) {
      preorderText = currentVariantPreorderMessage;
      // is some options on preorder
    } else if (selectedItems.some((item) => item.preorderMessage.length > 0)) {
      //
      if (
        variantsOnPreorder.some(
          (item) => item.preorderMessage == option0Message
        )
      ) {
        messages = selectedItems.filter((item) => item.optionNr !== 0);
        messages = messages.filter((item) => item.preorderMessage != "");
        // log.debug(preorderOrder);
        // log.debug(messages);
        // log.debug(sortMessagesByPreorder(messages,preorderOrder));
      } else {
        messages = selectedItems.filter((item) => item.preorderMessage != "");
        // log.debug(sortMessagesByPreorder(messages,preorderOrder));
      }
      messages = sortMessagesByPreorder(messages, preorderOrder);
      preorderText = messages.length > 0 ? messages[0].preorderMessage : "";
    }

    log.debug(preorderText);
    if (preorderText.length > 0) {
      // update line item
      if ($("#preorderText").length > 0) {
        $("#preorderText").val(preorderText);
      } else {
        $('[data-type="add-to-cart-form"]').append(
          `<input type="hidden" id="preorderText" name="properties[Preorder]" value="${preorderText}">`
        );
      }

      //update cart info
      if ($("#_preorder").length > 0) {
        $("#_preorder").val(preorderText);
      } else {
        $("#carto").append(
          `<input type="hidden" id="_preorder" name="attributes[_preorder]" value="true">`
        );
      }

      // hide timer
      $(".product-timer:not(.cart-timer)").each(function () {
        $(this).hide();
      });
    } else {
      // remove line item info about preorder
      $('[data-type="add-to-cart-form"] #preorderText').detach();
      // remove cart info about preorder
      $("#carto #__preorder").detach();

      // show timer
      $(".product-timer:not(.cart-timer)").show();
    }
  },
  hideSelectInputs: function () {
    $(".product-select-option-0").parent().parent().hide();
    $(".product-select-option-1").parent().parent().hide();
    $(".product-select-option-2").parent().parent().hide();
    $('[name="properties[Leg Color]"]').closest(".bold_option_dropdown").hide();
    $('[name="properties[Frame Color]"]').parent().hide();
    $('[name="properties[Desk Color]"]').parent().hide();
  },
  preSelects: function () {
    let _this = this;
    let href = window.location.href;
    if (href.includes("?variant") && window.selectedVariant != null) {
      window.selectedVariant.options.forEach((element, index) => {
        $(
          `.dropdown-option[data-option="${
            parseInt(index) + 1
          }"] .dropdown-items .dropdown-item`
        ).each(function (index) {
          //log.debug(element, $(this).text().trim().replace(/"/g,"&#34;"));
          if ($(this).text().trim().replace(/"/g, "&#34;") == element) {
            _this.selectVariant(this);
          }
        });
      });
    } else {
      log.debug(window.firstVariant);
      if (window.firstVariant != null) {
        window.firstVariant.options.forEach((element, index) => {
          // log.debug(element);
          $(
            `.dropdown-option[data-option="${
              parseInt(index) + 1
            }"] .dropdown-items .dropdown-item`
          ).each(function (index) {
            if ($(this).text() == element) {
              _this.selectVariant(this);
            }
          });
          $(
            `.swatches-wrapper[data-option="${parseInt(index) + 1}"] .swatch`
          ).each(function () {
            if ($(this).find(".swatch-image").attr("title") == element) {
              $(this).addClass("active");
            }
          });
        });
      }
    }
  },
  selectVariant: function (target) {
    var _this = this;
    log.debug("t", target);
    $(target).parent().find(".dropdown-item").removeClass("selected");
    $(target).addClass("selected");
    // log.debug($(target));
    // log.debug($(target).closest('.dropdown-option').data('option'));

    var optionSetSelect = document.getElementsByClassName(
      `product-select-option-${
        parseInt($(target).closest(".dropdown-option").data("option")) - 1
      }`
    );

    if (
      document.getElementsByName("properties[Leg Color]").length > 0 &&
      $(target).closest(".dropdown-option").data("type") == "Leg Color"
    ) {
      optionSetSelect = document.getElementsByName("properties[Leg Color]");
      // log.debug('bold');
    }
    if (document.getElementsByName("properties[Frame Color]").length > 0) {
      optionSetSelect = document.getElementsByName("properties[Frame Color]");
    }
    if (document.getElementsByName("properties[Desk Color]").length > 0) {
      optionSetSelect = document.getElementsByName("properties[Desk Color]");
    }
    var ind = 0;

    if (optionSetSelect[0][0].innerHTML.includes("Pick")) {
      ind = $(target).data("index") + 1;
      // log.debug('ind includes pick');
    } else {
      ind = $(target).data("index");
    }

    optionSetSelect[0].selectedIndex = parseInt(ind);

    //var ev = document.createEvent("HTMLEvents");
    //ev.initEvent("change", true);
    // Create and dispatch the event
    let ev = new Event("change", {
      bubbles: true,
      cancelable: true,
    });

    //element.dispatchEvent(event);
    optionSetSelect[0].dispatchEvent(ev);
    var selectedText = "";
    var preorderText = "";
    if (
      $(target).data("preorder") != undefined &&
      $(target).data("preorder").length > 0
    ) {
      selectedText = $(target).data("preorder");
      preorderText = $(target).data("preorder-message");
      log.debug($(target).closest(".dropdown-option").data("option") - 1);
      log.debug(preorderText);
    } else {
      var selectedText = $(target).text();
    }

    _this.setPreorder();
    $(target)
      .closest(".dropdown-option")
      .find(".dropdown-item-selected")
      .html(
        selectedText +
          `<svg width="11" height="11" aria-hidden="true" focusable="false" role="presentation" class="icon icon-caret" viewBox="0 0 10 9">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M9.354.646a.5.5 0 00-.708 0L5 4.293 1.354.646a.5.5 0 00-.708.708l4 4a.5.5 0 00.708 0l4-4a.5.5 0 000-.708z" fill="currentColor">
  </path></svg>`
      );

    if ($(target).closest(".dropdown-option").data("option") == "1") {
      _this.selectedOptions.option1 = $(target).text();
      if ($("body").hasClass("template-product.almost-perfect")) {
        $('.dropdown-option[data-option="2"] .dropdown-item').removeClass(
          "oos"
        );
        _this.setOos(
          _this.findOos($(target).text(), "", "").option2,
          '.dropdown-option[data-option="2"] .dropdown-item'
        );
      }

      $(`.product-select-option-0 option[value='${$(target).text()}']`).prop(
        "selected",
        true
      );
    }
    if ($(target).closest(".dropdown-option").data("option") == "2") {
      _this.selectedOptions.option2 = $(target).text();
      if ($("body").hasClass("template-product.almost-perfect")) {
        $('.dropdown-option[data-option="3"] .dropdown-item').removeClass(
          "oos"
        );
        _this.setOos(
          _this.findOosLegs(
            _this.selectedOptions.option1,
            _this.selectedOptions.option2
          ).option3,
          '.dropdown-option[data-option="3"] .dropdown-item'
        );
      }
      $(`.product-select-option-1 option[value='${$(target).text()}']`).prop(
        "selected",
        true
      );
    }
    if ($(target).closest(".dropdown-option").data("option") == "3") {
      _this.selectedOptions.option3 = $(target).text();
      $(`.product-select-option-2 option[value='${$(target).text()}']`).prop(
        "selected",
        true
      );
    }

    _this.closeDropdown(target);
  },
  events: function () {
    var _this = this;
    //_this.hideSelectInputs();
    function waitForElement(selector, callback, timeout = 5000) {
      const interval = 100; // Check every 100ms
      let elapsedTime = 0;

      const intervalId = setInterval(() => {
        const element = document.querySelector(selector);
        if (element) {
          clearInterval(intervalId);
          clearTimeout(timeoutId);
          callback(element);
        } else {
          elapsedTime += interval;
          if (elapsedTime >= timeout) {
            clearInterval(intervalId);
          }
        }
      }, interval); // Check every 100ms

      const timeoutId = setTimeout(() => {
        clearInterval(intervalId);
      }, timeout);
    }

    // Usage
    _this.preSelects();
    waitForElement(".bold_option_title", (element) => {
      _this.hideSelectInputs();
      _this.preSelects();
    });

    if ($("body").hasClass("template-product.almost-perfect")) {
      _this.findOosColours();
    }

    $(document).on("click", ".dropdown-item-selected", function (e) {
      // log.debug(prodVariants);
      e.preventDefault();
      // log.debug('test2');
      if (
        $(e.currentTarget)
          .closest(".dropdown-desc")
          .find(".dropdown-items")
          .hasClass("active")
      ) {
        $(e.currentTarget)
          .closest(".dropdown-desc")
          .find(".dropdown-items")
          .removeClass("active");
      } else {
        $(e.currentTarget)
          .closest(".dropdown-option")
          .find(".dropdown-items")
          .addClass("active");
        document
          .querySelectorAll("span.selection-required-message")
          .forEach((item) => {
            item.parentElement.removeChild(item);
          });
      }
    });
    $(document).on("click", ".dropdown-item", function (e) {
      _this.selectVariant(e.currentTarget);
    });

    // $(document).mouseup(function(e)
    // {
    //     var container = $(".dropdown-item-selected");

    //     // if the target of the click isn't the container nor a descendant of the container
    //     if (!container.is(e.target) && container.has(e.target).length === 0)
    //     {
    //       $('.dropdown-items').removeClass('active');
    //     }
    // });
    // $(window).on('scroll', (e) => {
    //   log.debug($(window).scrollTop());

    //     $('.dropdown-items').removeClass('active');

    // });
  },
  init: function () {
    this.events();
  },
};
if (typeof prodVariants !== "undefined" && prodVariants !== null) {
  setTimeout(dropdownDesc.init(), 500);
}
function toTitleCase(str) {
  return str
    .replace(/-/g, " ") // Replace dashes with spaces
    .replace(/\b\w/g, function (match) {
      return match.toUpperCase(); // Capitalize each word
    });
}

let productSwatches = {
  selectSwatch: function (target) {
    $(
      `.product-select-option-${$(target).data("option") - 1} option[value='${$(
        target
      )
        .find(".swatch-name")
        .text()}']`
    ).prop("selected", true);

    // var ev = document.createEvent("HTMLEvents");
    // ev.initEvent("change", true);
    let ev = new Event("change", {
      bubbles: true,
      cancelable: true,
    });
    document
      .querySelector(`.product-select-option-${$(target).data("option") - 1}`)
      .dispatchEvent(ev);
    $(target).parent().find(".swatch").removeClass("active");
    $(target).addClass("active");
    $(target)
      .closest(".swatches")
      .find(".title strong")
      .text($(target).find(".swatch-image").attr("title"));
  },
  setPreorder: function () {
    // if preorder value selected, add info about preorder to selected item
    log.debug("setPreorder");
    var selectedItems = [];

    // get current selects
    $(".dropdown-item.selected").each(function () {
      log.debug(
        $(this).closest(".dropdown-option").data("option") - 1,
        $(this).data("index"),
        $(this).data("preorder-message") ? $(this).data("preorder-message") : ""
      );
      selectedItems.push({
        optionNr: $(this).closest(".dropdown-option").data("option") - 1,
        indexNr: $(this).data("index"),
        preorderMessage: $(this).data("preorder-message")
          ? $(this).data("preorder-message")
          : "",
      });
    });

    //get current variant
    let url = new URL(window.location.href); // Use window.location.href to get the current URL
    let params = new URLSearchParams(url.search);
    let currentVariant = params.get("variant");
    log.debug(variantsOnPreorder);
    log.debug(selectedItems);

    function sortMessagesByPreorder(messages, preorderMessages) {
      return messages.sort((a, b) => {
        return (
          preorderMessages.indexOf(a.preorderMessage) -
          preorderMessages.indexOf(b.preorderMessage)
        );
      });
    }

    // array.find(item => item.optionNr === 1);
    var preorderText = "";
    var option0Message = selectedItems.find((item) => item.optionNr === 0)
      ? selectedItems.find((item) => item.optionNr === 0).preorderMessage
      : "";
    var currentVariantPreorderMessage = variantsOnPreorder.find(
      (item) => item.variant_id === currentVariant
    )
      ? variantsOnPreorder.find((item) => item.variant_id === currentVariant)
          .preorderMessage
      : "";
    // log.debug(option0Message, currentVariantPreorderMessage);
    var preorderText = "";

    // is current variant on preorder
    if (currentVariantPreorderMessage.length > 0) {
      preorderText = currentVariantPreorderMessage;
      // is some options on preorder
    } else if (selectedItems.some((item) => item.preorderMessage.length > 0)) {
      //
      if (
        variantsOnPreorder.some(
          (item) => item.preorderMessage == option0Message
        )
      ) {
        messages = selectedItems.filter((item) => item.optionNr !== 0);
        messages = messages.filter((item) => item.preorderMessage != "");
        // log.debug(preorderOrder);
        // log.debug(messages);
        // log.debug(sortMessagesByPreorder(messages,preorderOrder));
      } else {
        messages = selectedItems.filter((item) => item.preorderMessage != "");
        // log.debug(sortMessagesByPreorder(messages,preorderOrder));
      }
      messages = sortMessagesByPreorder(messages, preorderOrder);
      preorderText = messages.length > 0 ? messages[0].preorderMessage : "";
    }

    log.debug(preorderText);
    if (preorderText.length > 0) {
      // update line item
      if ($("#preorderText").length > 0) {
        $("#preorderText").val(preorderText);
      } else {
        $('[data-type="add-to-cart-form"]').append(
          `<input type="hidden" id="preorderText" name="properties[Preorder]" value="${preorderText}">`
        );
      }

      //update cart info
      if ($("#_preorder").length > 0) {
        $("#_preorder").val(preorderText);
      } else {
        $("#carto").append(
          `<input type="hidden" id="_preorder" name="attributes[_preorder]" value="true">`
        );
      }

      // hide timer
      $(".product-timer:not(.cart-timer)").each(function () {
        $(this).hide();
      });
    } else {
      // remove line item info about preorder
      $('[data-type="add-to-cart-form"] #preorderText').detach();
      // remove cart info about preorder
      $("#carto #__preorder").detach();

      // show timer
      $(".product-timer:not(.cart-timer)").show();
    }
  },
  selectDeskSwatch: function (target) {
    var self = this;

    // select 'target' variant on dropdown field
    $(
      `.product-select-option-${$(target).data("option") - 1} option[value='${$(
        target
      )
        .find(".swatch-image")
        .attr("title")}']`
    ).prop("selected", true);
    var optionSetSelect = document.getElementsByClassName(
      `product-select-option-${$(target).data("option") - 1}`
    );

    if (
      document.getElementsByName("properties[Leg Color]").length > 0 &&
      $(target).data("type") == "leg-color"
    ) {
      var optionSetSelect = document.getElementsByName("properties[Leg Color]");
      // log.debug('bold');
    }
    if (
      document.getElementsByName("properties[Frame Color]").length > 0 &&
      $(target).data("type") == "frame-color"
    ) {
      var optionSetSelect = document.getElementsByName(
        "properties[Frame Color]"
      );
      // log.debug('bold');
    }

    if (
      document.getElementsByName("properties[Desk Colour]").length > 0 &&
      $(target).data("type") == "desk-colour"
    ) {
      var optionSetSelect = document.getElementsByName(
        "properties[Desk Colour]"
      );
      // log.debug('bold');
    }
    if (
      document.getElementsByName("properties[Desktop Colour]").length > 0 &&
      $(target).data("type") == "desktop-colour"
    ) {
      var optionSetSelect = document.getElementsByName(
        "properties[Desktop Colour]"
      );
      // log.debug('bold');
    }
    if (
      document.getElementsByName("properties[Colour]").length > 0 &&
      $(target).data("type") == "colour"
    ) {
      var optionSetSelect = document.getElementsByName("properties[Colour]");
      // log.debug('bold');
    }
    if (
      document.getElementsByName("properties[Desk Color]").length > 0 &&
      $(target).data("type") == "desk-color"
    ) {
      var optionSetSelect = document.getElementsByName(
        "properties[Desk Color]"
      );
      // log.debug('bold');
    }
    if (
      document.getElementsByName("properties[Desktop Color]").length > 0 &&
      $(target).data("type") == "desktop-color"
    ) {
      var optionSetSelect = document.getElementsByName(
        "properties[Desktop Color]"
      );
      // log.debug('bold');
    }
    if (
      document.getElementsByName("properties[Color]").length > 0 &&
      $(target).data("type") == "color"
    ) {
      var optionSetSelect = document.getElementsByName("properties[Color]");
      // log.debug('bold');
    }
    log.debug(optionSetSelect);
    var ind = 0;

    if (optionSetSelect[0][0].innerHTML.includes("Pick")) {
      ind = $(target).data("index") + 1;
      // log.debug('ind includes pick');
    } else {
      ind = $(target).data("index");
    }

    optionSetSelect[0].selectedIndex = parseInt(ind);

    // var ev = document.createEvent("HTMLEvents");
    // ev.initEvent("change", true);
    let ev = new Event("change", {
      bubbles: true,
      cancelable: true,
    });
    optionSetSelect[0].dispatchEvent(ev);
    log.debug("target", $(target));
    var targetDataType = toTitleCase($(target).data("type"));
    // log.debug(targetDataType);
    // log.debug($(`.dropdown-option[data-type="${targetDataType}"]`).find('.dropdown-item-selected').text());
    $(`.dropdown-option[data-type="${targetDataType}"]`)
      .find(".dropdown-item-selected")
      .text($(target).find(".swatch-image").attr("title"));
    $(`.dropdown-option[data-type="${targetDataType}"]`)
      .find(".dropdown-item")
      .removeClass("selected");
    $(`.dropdown-option[data-type="${targetDataType}"]`)
      .find(`.dropdown-item[data-index="${$(target).data("index")}"]`)
      .addClass("selected");

    //$(target).closest('.dropdown-option').find('.dropdown-item-selected').text($(target).text());

    document
      .querySelector(`.product-select-option-${$(target).data("option") - 1}`)
      .dispatchEvent(ev);
    $(target)
      .closest(".swatches-wrapper")
      .find(".swatch")
      .removeClass("active");
    $(target).addClass("active");
    // change label to preorder if preorder set
    log.debug($(target).data("preorder"));
    let preorderT = "";
    let preorderCart = "";
    let swatchTitle = $(target).find(".swatch-image").attr("title");
    log.debug(swatchTitle);
    if ($(target).data("preorder") != undefined) {
      preorderT = $(target).data("preorder");
      preorderCart = $(target).data("preorder-message");
      $(target).closest(".desk-swatches").find(".title strong").text(preorderT);
    } else {
      $(target)
        .closest(".desk-swatches")
        .find(".title strong")
        .text($(target).find(".swatch-image").attr("title"));
    }

    self.setPreorder();
  },
  triggerFirstVariant: function () {
    var self = this;
    $(".desk-swatches .swatch.active").each(function () {
      self.selectDeskSwatch(this);
    });
  },
  showLabel: function () {
    log.debug($(".bold_option_title:contains('Cable Management & Power')"));
    $(".bold_option_title:contains('Cable Management & Power')").each(
      function () {
        $(this).css("display", "block");
        $(this).css("font-size", "14px");
        $(this).css("margin-bottom", "16px");
        $(this).css("text-align", "left");
        $(this).css("margin-top", "24px");
      }
    );
  },
  events: function () {
    var self = this;
    $(".swatches-wrapper").on("click", ".swatch", function (e) {
      e.preventDefault();
      log.debug(e.currentTarget);
      if ($(e.currentTarget).closest(".swatches").hasClass("desk-swatches")) {
        self.selectDeskSwatch(e.currentTarget);
      } else {
        self.selectSwatch(e.currentTarget);
      }
      self.showLabel();
    });
  },
  init: function () {
    this.triggerFirstVariant();
    this.events();
    this.showLabel();
  },
};
if (typeof prodVariants !== "undefined" && prodVariants !== null) {
  setTimeout(productSwatches.init(), 500);
}

function updateCountdown() {
  // Get current time in the New York (America/New_York) timezone
  var now = new Date();
  var options = { timeZone: "America/New_York", hour12: false };
  var nowInNewYork = new Date(now.toLocaleString("en-US", options));
  const currentHour = nowInNewYork.getHours();
  const currentDay = nowInNewYork.getDay();
  if (
    (currentDay === 6 && currentHour >= 0) ||
    currentDay === 0 ||
    (currentDay === 5 && currentHour >= 23)
  ) {
    $(".product-timer-wrapper p").html(
      "<strong>🚚  Same day</strong> dispatch on orders before 2pm."
    );
  } else if (currentHour >= 0 && currentHour < 14) {
    const noon = new Date(now);
    noon.setHours(14, 0, 0, 0); // Set to 14:00 PM today

    const diff = noon - nowInNewYork;

    const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((diff % (1000 * 60)) / 1000);

    $(".product-timer-wrapper p").html(
      `🚚  Order in the next <strong>${hours} hours, ${minutes} minutes</strong> for same day dispatch.`
    );
  } else {
    $(".product-timer-wrapper p").html(
      "<strong>🚚  Same day</strong> dispatch for orders before 2pm."
    );
  }

  if (window.innerWidth < 768) {
    $(".bottom-products-slider").before($(".product-timer.cart-timer"));
    $(".cart-left").before($(".product-timer.cart-timer"));
  } else {
    $(".product-timer.cart-timer").prependTo(".timer-container");
  }
}

// Initial call and set interval to update every second
updateCountdown();
setInterval(updateCountdown, 1000);

function initReadMore(popupRoot = document) {
  popupRoot.querySelectorAll(".readMoreWrapper").forEach((wrapper) => {
    const content = wrapper.querySelector(".readMoreContent");
    const toggle = wrapper.querySelector(".readMoreToggle");
    if (!content || !toggle) return;
    const defaultMaxHeight = 5 * 1.5 * 16;
    const defaultLines = null;
    let readMoreText = toggle.textContent.trim() || "Read more";
    let readLessText = "Read less";
    if (toggle.dataset.readLessText) readLessText = toggle.dataset.readLessText;
    if (toggle.dataset.readMoreText) readMoreText = toggle.dataset.readMoreText;
    const maxHeight = wrapper.dataset.readMoreHeight
      ? parseInt(wrapper.dataset.readMoreHeight, 10)
      : defaultMaxHeight;
    const lines = wrapper.dataset.readMoreLines
      ? parseInt(wrapper.dataset.readMoreLines, 10)
      : defaultLines;
    const applyClamp = () => {
      if (lines) {
        content.classList.add("readMoreClamp");
        content.style.webkitLineClamp = lines;
        content.style.maxHeight = "";
        content.style.overflow = "";
      } else {
        content.classList.remove("readMoreClamp");
        content.style.webkitLineClamp = "";
        content.style.maxHeight = maxHeight + "px";
        content.style.overflow = "hidden";
      }
    };
    const removeClamp = () => {
      content.classList.remove("readMoreClamp");
      content.style.webkitLineClamp = "";
      content.style.maxHeight = "";
      content.style.overflow = "";
    };
    applyClamp();
    wrapper.classList.remove("isExpanded");
    toggle.textContent = readMoreText;
    toggle.onclick = () => {
      if (wrapper.classList.contains("isExpanded")) {
        applyClamp();
        wrapper.classList.remove("isExpanded");
        toggle.textContent = readMoreText;
      } else {
        removeClamp();
        wrapper.classList.add("isExpanded");
        toggle.textContent = readLessText;
      }
    };
  });
}
